import React from 'react';

const ReactAppContext = React.createContext();
ReactAppContext.displayName = 'ReactAppContext';

export default ReactAppContext;
